import inspection from './inspection.json';

export default { ...inspection };
